import Message from './Message';
// Change color of component
let $saveColor = $('form.editBackgroundColor'),
    $componentId;


$saveColor.on('submit', function(e){
    e.preventDefault();

    $componentId = $(this).attr('page-component-id');
    let $bgColor = $(this).find('select[name=backgroundColor]').val(),
        $borderCheckbox = $(this).find('input[name=topBorder]');

    if($borderCheckbox.is(':checked')){
        $borderCheckbox = 'top-blue-border';
    } else {
        $borderCheckbox = '';
    }

    $.ajax({
        url: '/admin/api/pages/background/' + $componentId,
        method: 'POST',
        data: {
            backgroundColor: $bgColor,
            topBorder: $borderCheckbox
        },
        success: function(data) {
            let $component = $('#component-'+ $componentId +'');
            let $borderLine = $('#border-line-'+ $componentId +'');
            if($bgColor == ''){
                $component.removeClass("bg-grey");
                console.log(data.color);
            } else {
                $component.addClass(data.color);
            }

            if($borderCheckbox == '') {
                $borderLine.removeClass("top-blue-border");
                console.log(data.border);
            } else {
                $borderLine.addClass(data.border);
            }
        },
        error: function( err ) {
            console.log(err)
        }
    })
});


// WEBPACK FOOTER //
// ./resources/assets/js/EditBgColor.js